var map = {
	"./favicon.ico": 24,
	"./first_aid": 7,
	"./first_aid.png": 7,
	"./first_aid2": 8,
	"./first_aid2.png": 8,
	"./orientation_logo": 9,
	"./orientation_logo.png": 9
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;